import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages, SdkErrorNames } from "./errorsMetadata";

/**
 * @description Default error for portfolio
 */
export class PortfolioError extends CedeSDKError {
  constructor(code = SdkErrorCodes.PORTFOLIO_ERROR, message = SdkErrorMessages.PORTFOLIO_ERROR) {
    super(code, message);
    this.name = "PortfolioError";
  }
}

/**
 * @description Thrown when there isn't enough balance to perform the operation
 */
export class InsufficientBalanceError extends PortfolioError {
  constructor() {
    super(SdkErrorCodes.NOT_ENOUGH_BALANCE, SdkErrorMessages.NOT_ENOUGH_BALANCE);
    this.name = SdkErrorNames.INSUFFICIENT_BALANCE;
  }
}

/**
 * @description Thrown when there isn't enough margin for a futures/perpetual order
 */
export class InsufficientMarginError extends InsufficientBalanceError {
  constructor() {
    super();
    this.code = SdkErrorCodes.INSUFFICIENT_MARGIN;
    this.message = SdkErrorMessages.INSUFFICIENT_MARGIN;
    this.name = SdkErrorNames.INSUFFICIENT_MARGIN;
  }
}
